
import { Component, Vue } from "vue-property-decorator";
import { getDeviceGun, deviceDoDebug, getDebugResult } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";

@Component
export default class EquipmentTable extends Vue {
  private modalShow = false;
  private loading = false;

  private FormData: objAny = {};
  private debugType: objAny = {
    1: "费率下发",
    2: "二维码下发",
    3: "实时数据"
  };
  private formItem: objAny = {
    debugContent: [],
    deviceList: [],
    snList: []
  };
  private ruleInline: objAny = {
    debugContent: [
      {
        required: true,
        message: "请选择调试内容",
        trigger: "change",
        type: "array"
      }
    ]
  };

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: "序列号",
      key: "serialNumber",
      minWidth: 103
    },
    {
      title: "调试结果",
      key: "result",
      minWidth: 83
    },
    {
      title: "详情",
      key: "detail",
      minWidth: 140
    }
  ];

  public open(arr: string[]): void {
    this.modalShow = true;
    this.formItem.snList = arr;
    this.formItem.debugContent = [];
    this.formItem.deviceList = [];
    this.getTableList();
    this.$nextTick((): void => {
      this.FormData = this.$refs["formItem"];
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleSubmit(): void {
    this.FormData.validate((valid: boolean): void => {
      if (valid) {
        this.deviceDoDebug();
      }
    });
  }

  async deviceDoDebug(): Promise<void> {
    const ret = await deviceDoDebug(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success("调试成功");
      this.getTableListResult();
    }
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getDeviceGun({
      snList: this.formItem.snList
    });
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.formItem.deviceList = ret.data;
    }
    this.loading = false;
  }
  async getTableListResult(): Promise<void> {
    this.loading = true;
    const ret = await getDebugResult(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.formItem.deviceList = ret.data;
    }
    this.loading = false;
  }
}
